import React from 'react';
import { cn } from '@ui/atoms/utils/utils';

const SearchResultsLoader = ({
    description = 'Searching for results...',
    className,
}) => {
    return (
        <div
            className={cn(
                'w-full min-h-[400px] justify-center flex flex-col items-center gap-6 p-16',
                className
            )}
        >
            <div className="!w-10 !h-10 button-loader-primary !md:w-16 !md:h-16 before:!border-4 border-transparent before:!border-primary-500" />
            {description && (
                <div className="text-center text-gray-500 p3-medium">
                    {description}
                </div>
            )}
        </div>
    );
};

export default SearchResultsLoader;
